// react core
import React from "react";

// material design
import { styled } from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// fonts and icons
import LoginAmazon from "assets/logos/amazon-connect.png";
import LoginApple from "assets/logos/apple-connect.png";
import LoginGoogle from "assets/logos/google-connect.png";
import LoginEntzy from "assets/logos/entzy-dark.png";

// entzy config and components
import configEntzy from "components/config/ConfigEntzy";

function ConnectProviders(props) {
  const images = [
    {
      url: LoginGoogle,
      title: "Google",
      width: "100%",
      click: () => props.handleIdentityProvider("Google"),
    },
    {
      url: LoginApple,
      title: "Apple",
      width: "100%",
      click: () => props.handleIdentityProvider("Apple"),
    },
    {
      url: LoginAmazon,
      title: "Amazon",
      width: "100%",
      click: () => props.handleIdentityProvider("Amazon"),
    },
    {
      url: LoginEntzy,
      title: "Entzy",
      width: "100%",
      click: () => props.handleIdentityProvider("Entzy"),
    },
  ];

  const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: "relative",
    height: 150,
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
      height: 100,
    },
    "&:hover, &.Mui-focusVisible": {
      zIndex: 1,
      "& .MuiImageBackdrop-root": {
        opacity: 0.15,
      },
      "& .MuiImageMarked-root": {
        opacity: 0,
      },
      "& .MuiTypography-root": {
        boxShadow: `
          inset 0 0 0 1px rgba(255, 0, 255, 0.6),
          0 0 6px 2px rgba(255, 0, 255, 0.35),
          0 0 14px 4px rgba(255, 105, 180, 0.25)
        `,
        filter: `
          drop-shadow(0 0 4px rgba(255, 105, 180, 0.25))
          drop-shadow(0 0 10px rgba(255, 0, 255, 0.15))
        `,
        backgroundColor: "#000",
        borderRadius: "30px",
        opacity: 0.9,
      },
    },
  }));

  const ImageSrc = styled("span")({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundPosition: "center 40%",
  });

  const Image = styled("span")(({ theme }) => ({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.common.white,
  }));

  const ImageBackdrop = styled("span")(({ theme }) => ({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.6,
    transition: theme.transitions.create("opacity"),
  }));

  return (
    <Box
      className="box-default"
      sx={{
        py: configEntzy.APP_SPACING_MD,
      }}
    >
      <Box
        className="box-inline shadow-purple-glow"
        sx={{
          width: configEntzy.AVATAR_CONTAINER_MD,
          borderRadius: configEntzy.BORDER_SIZE_XL,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            borderRadius: configEntzy.BORDER_SIZE_XL,
            overflow: "hidden",
          }}
        >
          {images.map((image) => (
            <ImageButton
              focusRipple
              key={image.title}
              style={{
                width: image.width,
              }}
              onClick={image.click}
            >
              <ImageSrc style={{ backgroundImage: `url(${image.url})` }} />
              <ImageBackdrop className="MuiImageBackdrop-root" />
              <Image>
                <Typography
                  component="span"
                  variant="subtitle2"
                  color="inherit"
                  sx={{
                    position: "relative",
                    p: 4,
                    pt: 2,
                    pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                  }}
                >
                  {image.title}
                </Typography>
              </Image>
            </ImageButton>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default ConnectProviders;
